// Ab dieser Scrolltiefe (px) wird die Navigation weiss
const SCROLL_THRESHOLD = 160

export function initNav() {
  const header = document.querySelector("[data-header]")
  if (!header) return

  const toggle = header.querySelector("[data-nav-toggle]")
  const menu = header.querySelector(".site-nav__menu")

  const onScroll = () => {
    header.classList.toggle("is-scrolled", window.scrollY > SCROLL_THRESHOLD)
  }
  onScroll()
  window.addEventListener("scroll", onScroll, { passive: true })

  const isOpen = () => header.classList.contains("is-open")

  const setOpen = (open) => {
    header.classList.toggle("is-open", open)
    document.documentElement.classList.toggle("nav-open", open)
    toggle?.setAttribute("aria-expanded", open ? "true" : "false")
    if (open) menu?.querySelector("a")?.focus({ preventScroll: true })
  }

  toggle?.addEventListener("click", () => setOpen(!isOpen()))

  // Menü-Links und Logo (Sprung nach oben) schliessen das Menü
  header
    .querySelectorAll(".site-nav__link, .site-header__logo")
    .forEach((link) => {
      link.addEventListener("click", () => setOpen(false))
    })

  // Menü schliessen, wenn auf Desktop-Breite gewechselt wird
  window.matchMedia("(min-width: 1024px)").addEventListener("change", (e) => {
    if (e.matches) setOpen(false)
  })

  document.addEventListener("keydown", (e) => {
    if (!isOpen()) return
    if (e.key === "Escape") {
      setOpen(false)
      toggle?.focus()
    }
    // Fokus im offenen Menü halten (Tab-Taste)
    if (e.key === "Tab") {
      // alle sichtbaren Elemente im Header: Logo, Burger, Menü, Spenden
      const items = [...header.querySelectorAll("a[href], button")]
      const first = items[0]
      const last = items.at(-1)
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        first.focus()
      }
    }
  })
}
